/**
 * Shopify filter value.
 * @typedef {Object} FilterValue
 * @property {boolean} active - Whether the filter is currently applied.
 * @property {number} count - Number of products in results set that match this value.
 * @property {string} label
 * @property {string} value
 * @property {string} paramName
 * @property {string} urlToAdd
 * @property {string} urlToRemove
 */
/**
 * Shopify filter data.
 * @typedef {Object} Filter
 * @property {string} paramName
 * @property {string} presentation
 * @property {string} urlToRemove
 * @property {FilterValue[]} values
 */

class PlugFilterSlider extends HTMLElement {
    constructor() {
        super();
        /** @type {Filter} */
        this.filterData = JSON.parse(this.querySelector("[data-filter-json]").innerHTML);
    }

    disconnectedCallback() {
        if (typeof this.removeListeners === "function") {
            this.removeListeners();
        }
    }

    hideParentBlock() {
        const parentBlock = this.closest(".plug-filter-block");
        if (parentBlock) {
            parentBlock.classList.add("plug-hide");
        } else {
            console.warn("Can't find parent block for plug-range-slider.");
        }
    }

    showParentBlock() {
        const parentBlock = this.closest(".plug-filter-block");
        if (parentBlock) {
            parentBlock.classList.remove("plug-hide");
        } else {
            console.warn("Can't find parent block for plug-range-slider.");
        }
    }
}
if (!window.customElements.get("plug-filter-slider")) {
    window.customElements.define("plug-filter-slider", PlugFilterSlider);
}
